import _styled from "styled-components";
import React, { useCallback } from 'react';
import { SearchField } from '@noths/polaris-client-ribbons-design-system';
import * as styles from "./SearchBarContainer.styles";
import { SearchSuggestions } from "../SearchSuggestions/SearchSuggestions";
import { useSearchContext } from "../../../context/SearchContext/useSearchContext";
import { SEARCH_RESULTS_PATH } from "../../../hooks/useSearch/utils/buildSearchPath";
export var SearchBarContainer = function SearchBarContainer() {
  var _useSearchContext = useSearchContext(),
    _useSearchContext$sea = _useSearchContext.search,
    handleSearch = _useSearchContext$sea.handleSearch,
    hideSuggestions = _useSearchContext$sea.hideSuggestions,
    isSearchInFocus = _useSearchContext$sea.isSearchInFocus,
    isSuggestionsShown = _useSearchContext$sea.isSuggestionsShown,
    resetAll = _useSearchContext$sea.resetAll,
    resetSelectedSuggestion = _useSearchContext$sea.resetSelectedSuggestion,
    searchTerm = _useSearchContext$sea.searchTerm,
    selectNextSearchSuggestion = _useSearchContext$sea.selectNextSearchSuggestion,
    selectPreviousSearchSuggestion = _useSearchContext$sea.selectPreviousSearchSuggestion,
    selectedSuggestionTerm = _useSearchContext$sea.selectedSuggestionTerm,
    setSearchFocus = _useSearchContext$sea.setSearchFocus,
    setSearchTerm = _useSearchContext$sea.setSearchTerm;
  var onKeyDown = useCallback(function (e) {
    switch (e.key) {
      case 'ArrowUp':
        e.preventDefault();
        selectPreviousSearchSuggestion();
        break;
      case 'ArrowDown':
        e.preventDefault();
        selectNextSearchSuggestion();
        break;
      case 'Escape':
        resetSelectedSuggestion();
        hideSuggestions();
        break;
      default:
        if (e.key !== 'Enter') {
          resetSelectedSuggestion();
        }
    }
  }, [hideSuggestions, resetSelectedSuggestion, selectNextSearchSuggestion, selectPreviousSearchSuggestion]);
  var onSubmit = useCallback(function (e) {
    e.preventDefault();
    handleSearch();
  }, [handleSearch]);
  var isAnyChildStillInFocus = function isAnyChildStillInFocus(e) {
    return e.currentTarget.contains(e.relatedTarget);
  };
  var onBlur = useCallback(function (e) {
    if (!isAnyChildStillInFocus(e)) {
      setSearchFocus(false);
    }
  }, [setSearchFocus]);
  var onChange = useCallback(function (e) {
    setSearchTerm(e.currentTarget.value);
  }, [setSearchTerm]);
  var onFocus = useCallback(function () {
    setSearchFocus(true);
  }, [setSearchFocus]);
  return /*#__PURE__*/React.createElement(_StyledDiv, {
    onBlur: onBlur,
    $_css: styles.container
  }, /*#__PURE__*/React.createElement("form", {
    action: SEARCH_RESULTS_PATH,
    onSubmit: onSubmit,
    role: "search"
  }, /*#__PURE__*/React.createElement(SearchField, {
    ariaAutocomplete: "list",
    ariaExpanded: isSuggestionsShown,
    ariaOwns: "suggestionList",
    displayValue: selectedSuggestionTerm,
    id: "search-term",
    onChange: onChange,
    onFocus: onFocus,
    onKeyDown: onKeyDown,
    onReset: resetAll,
    placeholder: "Search our marketplace",
    showSubmitButtonAsFocused: isSearchInFocus,
    value: searchTerm
  })), isSuggestionsShown && /*#__PURE__*/React.createElement(SearchSuggestions, null));
};
var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "SearchBarContainer___StyledDiv",
  componentId: "sc-1vmyou3-0"
})(["", ""], function (p) {
  return p.$_css;
});